const storefrontApiCustomScalars = {
  // Keep in sync with the definitions in the app/nextjs/codegen.ts!
  DateTime: "string",
  Decimal: "string",
  HTML: "string",
  URL: "string",
  Color: "string",
  UnsignedInt64: "string"
};
const customerAccountApiCustomScalars = {
  DateTime: "string",
  Decimal: "string",
  HTML: "string",
  ISO8601DateTime: "string",
  URL: "string",
  UnsignedInt64: "string"
};
export {
  customerAccountApiCustomScalars,
  storefrontApiCustomScalars
};
//# sourceMappingURL=codegen.helpers.mjs.map
